import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './xero-integration-callback.scss';
import {
  xeroConnect,
} from '../../actions/accountingIntegrationActions';
import Alert from 'constants/alert-messages';

/**
 * Xero Integration Callback
 * @returns JSX Element
 */
const XeroIntegrationCallback = () => {
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);

  const xeroConnectLoaded = useSelector((state) => state.accountingIntegrationStore.xeroConnectLoaded);
  const xeroConnectLoading = useSelector((state) => state.accountingIntegrationStore.xeroConnectLoading);
  const xeroConnectError = useSelector((state) => state.accountingIntegrationStore.xeroConnectError);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const stateParam = queryParams.get('state');
    const authorizationCodeParam = queryParams.get('code');

    if (!stateParam || !authorizationCodeParam) {
      setIsError(true);
      return;
    }

    const [assignedGrandfatherClientNumber, accountId] = stateParam.split(';');

    if (!assignedGrandfatherClientNumber || !accountId) {
      setIsError(true);
      return;
    }

    dispatch(xeroConnect(assignedGrandfatherClientNumber, accountId, authorizationCodeParam));
  }, []);

  const renderContent = () => {
    if (xeroConnectError || isError) {
      return Alert.XERO_CONNECT_ERROR;
    }
    if (xeroConnectLoading) {
      return Alert.XERO_CONNECT_LOADING;
    }
    if (xeroConnectLoaded) {
      return Alert.XERO_CONNECT_LOADED;
    }
  };

  return <>
    {renderContent()}
  </>;
};

export default XeroIntegrationCallback;
